const userverURL = '/userver/api/data';
const appEndpoint = {
  findApplicant: `${userverURL}/findapplicant`,
  reqSecurityCode: `${userverURL}/getsecuritycode`,
  createUser: `${userverURL}/register`,
  forgotUserId: `${userverURL}/forgotuserid`,
  forgotPassword: `${userverURL}/forgotpassword`,
  resetPassword: `${userverURL}/resetpassword`,
  validateToken: `${userverURL}/validatetoken`,
  loginConfig: `${userverURL}/loginconfig`,
  auditLogs:  `${userverURL}/log/audit`,
  getMicrositeUrl: `${userverURL}/mlde/redirect`,
  verfiyApplicant: `${userverURL}/userapplication/verify`,
  appLog: `${userverURL}/app/log`,
  siteMaintenance: `${userverURL}/maintenance`,
};

export default appEndpoint;
